// import hooks
import React from "react";
const Footer = () => {
  return (
    <div className="w-full bg-[#CC8C08] h-fit mt-5 py-3 px-5 lg:px-10 text-center text-white">
      <p>Created by Paul To (https://tovanhuong.id.vn/)</p>
    </div>
  );
};

export default Footer;
